import { Component, Mixins, Vue } from 'vue-property-decorator';
// @ts-ignore
import listPageMixin, { createSlotComp } from '@root/common/mixins/list-page/list-page.vue';
import uiConfig from './pageBootstrap.json';
import { storedCardPaymentExport } from '@/api/fixed-car-management';
import moment from 'moment';

@Component({
  name: 'StoredCardPayment',
  components: {
    operation: createSlotComp(`<span></span>`),
    exportArea: createSlotComp(`<span>
    <Authorized resource="system:financial:export">
    <a-button @click="vm.exportPayment"
                type="primary"
                ghost
                icon="export"
              >导出</a-button></Authorized>
    </span>`)
  }
})
export default class StoredCardPayment extends Mixins(listPageMixin) {
  customPrimaryUIConfig = uiConfig;
  downLoadErrMsgLoading = false;
  async exportPayment() {
    try {
      if (this.downLoadErrMsgLoading) return;
      this.downLoadErrMsgLoading = true;
      if (this.filterParam.paidTimeEnd) {
        this.filterParam.paidTimeEnd = moment(this.filterParam.paidTimeEnd).format('YYYY-MM-DD 23:59:59');
      } else {
        this.filterParam.paidTimeEnd = '';
      }
      if (this.filterParam.paidTimeStart) {
        this.filterParam.paidTimeStart = moment(this.filterParam.paidTimeStart).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.filterParam.paidTimeStart = '';
      }
      if (this.filterParam.paidTimeEnd === 'Invalid date') {
        this.filterParam.paidTimeEnd = '';
      }
      if (this.filterParam.paidTimeStart === 'Invalid date') {
        this.filterParam.paidTimeStart = '';
      }
      const res = await storedCardPaymentExport(
        { ...this.filterParam, parkIds: this.filterParam.parkIds.join(',') },
        '储值卡消费记录'
      );
    } catch (e) {
      console.error(e);
    } finally {
      this.downLoadErrMsgLoading = false;
    }
  }

  get computedPagination() {
    return {
      ...this.pagination,
      pageSize: this.pagination.pageSize,
      showTotal: () => `总共 ${this.totalRecordNumFromHttpRes} 条`
    };
  }
}
